export default {
    CREATE_USER: () => '/auth/register',
    GET_ALL_USER: (query) => `/auth/getAllUser?${query ? query : ''}`,
    DELETE_USER: (id) => `/auth/deleteUser/${id}`,
    UPDATE_USER: (id) => `/auth/updateUser/${id}`,
    GET_USER_ID: (id) => `/auth/getUserById/${id}`,
    ASSIGN_GROUP_USER: () => '/groupUser/createGroupUser',
};
